define(["react","prop-types","classnames","@bingads-webui-react/with-default-styles"], function(__WEBPACK_EXTERNAL_MODULE__3__, __WEBPACK_EXTERNAL_MODULE__4__, __WEBPACK_EXTERNAL_MODULE__5__, __WEBPACK_EXTERNAL_MODULE__7__) { return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 66);
/******/ })
/************************************************************************/
/******/ ({

/***/ 3:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__3__;

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__4__;

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__5__;

/***/ }),

/***/ 66:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(67);


/***/ }),

/***/ 67:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Progress", {
  enumerable: true,
  get: function get() {
    return _progress.Progress;
  }
});
Object.defineProperty(exports, "RadialProgress", {
  enumerable: true,
  get: function get() {
    return _radialProgress.RadialProgress;
  }
});

var _progress = __webpack_require__(68);

var _radialProgress = __webpack_require__(69);

/***/ }),

/***/ 68:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Progress = void 0;

var _react = _interopRequireDefault(__webpack_require__(3));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Progress = props => {
  const progressPercentage = props.progressPercentage;
  const styles = {
    width: `${progressPercentage * 100}%`
  };
  return _react.default.createElement("div", {
    className: "progress"
  }, _react.default.createElement("div", {
    className: "progress-bar",
    role: "progressbar",
    "aria-valuemin": "0",
    "aria-valuemax": "100",
    style: styles
  }));
};

exports.Progress = Progress;
Progress.propTypes = {
  progressPercentage: _propTypes.default.number
};
Progress.defaultProps = {
  progressPercentage: 0.2
};

/***/ }),

/***/ 69:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RadialProgress = exports.RadialProgressUnthemed = void 0;

var _react = _interopRequireDefault(__webpack_require__(3));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _withDefaultStyles = __webpack_require__(7);

var _getStyles = __webpack_require__(70);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const RadialProgressUnthemed = props => {
  const progressPercentage = props.progressPercentage,
        size = props.size,
        stroke = props.stroke,
        strokeWidth = props.strokeWidth,
        classes = props.classes,
        className = props.className;
  const radius = size / 2 - strokeWidth / 2;
  const strokeLength = Math.PI * 2 * radius;
  const sizePixels = `${size}px`;
  return _react.default.createElement("div", {
    className: (0, _classnames.default)('radial-progress', classes.container, className),
    style: {
      width: sizePixels,
      height: sizePixels
    }
  }, _react.default.createElement("svg", {
    className: classes.svg,
    width: size,
    height: size,
    viewBox: `0 0 ${size} ${size}`
  }, _react.default.createElement("circle", {
    className: classes.circle,
    cx: `${size / 2}`,
    cy: `${size / 2}`,
    r: `${radius}`,
    style: {
      strokeWidth
    }
  }), _react.default.createElement("circle", {
    className: (0, _classnames.default)(classes.circle, classes.primary),
    cx: `${size / 2}`,
    cy: `${size / 2}`,
    r: `${radius}`,
    style: {
      stroke,
      strokeWidth,
      strokeDasharray: `${progressPercentage * strokeLength} ${strokeLength}`
    }
  })), _react.default.createElement("div", {
    className: (0, _classnames.default)('radial-progress-text', classes.text),
    style: {
      width: sizePixels,
      height: sizePixels,
      lineHeight: sizePixels
    }
  }, `${parseInt(progressPercentage * 100, 10)}%`));
};

exports.RadialProgressUnthemed = RadialProgressUnthemed;
RadialProgressUnthemed.propTypes = {
  progressPercentage: _propTypes.default.number.isRequired,
  size: _propTypes.default.number,
  strokeWidth: _propTypes.default.number,
  stroke: _propTypes.default.string,
  className: _propTypes.default.string,
  classes: _propTypes.default.shape({}).isRequired
};
RadialProgressUnthemed.defaultProps = {
  size: 128,
  stroke: '#107C10',
  strokeWidth: 14,
  className: null
};
const RadialProgress = (0, _withDefaultStyles.withDefaultStyles)(RadialProgressUnthemed, _getStyles.getStyles);
exports.RadialProgress = RadialProgress;

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__7__;

/***/ }),

/***/ 70:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getStyles = void 0;

const getStyles = (_, {
  palette = {}
}) => ({
  container: {
    position: 'relative'
  },
  svg: {
    position: 'absolute',
    left: 0,
    top: 0,
    transform: 'rotate(270deg)'
  },
  circle: {
    fill: 'transparent',
    strokeDashoffset: '0',
    strokeLinecap: 'round',
    stroke: palette.neutralLight
  },
  primary: {
    stroke: palette.green
  },
  text: {
    position: 'absolute',
    left: 0,
    top: 0,
    textAlign: 'center'
  }
});

exports.getStyles = getStyles;

/***/ })

/******/ })});;
